import React from 'react';
import LogoAr from './images/logoar.png';
import LogoEn from './images/logo.webp';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import './css/mainviewnav.css';
import { CreditCardIcon, BanknotesIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const MainViewNav = () => {
  const { t, language } = useTranslation();
  const Logo = language === 'ar' ? LogoEn : LogoEn;
  
  return (
    <div className='main-view-nav'>
        <div className='container-fluid'>
            <div className='main-view-nav-content'>
                <div className='view-branches-btn'>
                    <Link to="/branches">
                        <button><InformationCircleIcon className='icon' /></button>
                    </Link>
                </div>

                <div className="logo-content">
                    <div>
                        <h2> {t('nav.brandName')} </h2>
                        <ul>
                            <li> <CreditCardIcon className='icon' /></li>
                            <li> <BanknotesIcon className='icon' /></li>
                        </ul>
                    </div>
                    <img src={Logo} alt='Logo' className='logo' />
                </div>
            </div>
        </div>
    </div>
  )
}

export default MainViewNav